<template>
  <div>
    <div id="homepage" class="content-wrapper page">
      <section class="row wat-wij-doen">
        <div class="col text">
          <h1>Wat wij doen</h1>
          <p>
            Wij verzorgen meer dan 160.000 print- en scanopdrachten voor
            professionals per jaar, vanuit vijf locaties verspreid over het
            land. Wij doen dit voor onder andere het bedrijfsleven, de bouw, de
            overheid, het onderwijs, de gezondheidszorg en de culturele sector.
            <br />Het printwerk wordt de volgende werkdag door onze eigen
            koeriers bezorgd door heel Nederland.
          </p>
          <router-link class="link-button" to="/wat-wij-doen"
            >Lees hier meer over wat wij doen</router-link
          >
        </div>
        <div class="col image">
          <img
            src="@/images/pages/bestellen-bezorgen-door-heel-nederland.svg"
            alt="wat-wij-doen"
          />
          <div class="bg-circle g-w"></div>
        </div>
      </section>

      <section id="hoe-doen-wij-dat" class="row reverse">
        <div class="col text">
          <h1>Hoe doen wij dat</h1>
          <p>
            Alle printopdrachten voeren wij in eigen beheer uit vanuit onze vijf
            vestigingen verspreid over het land. Onder supervisie van uw
            persoonlijke contactpersoon bij Rijnja, verzorgen wij uw print- en
            repro-opdrachten makkelijk en snel van de voorbereiding tot de
            distributie met eigen koeriers en levering binnen een werkdag.
          </p>
          <router-link class="link-button" to="/hoe-doen-wij-dat"
            >Lees hier meer over hoe wij dat doen</router-link
          >
        </div>
        <div class="col image">
          <img
            src="@/images/pages/kwaliteit-duurzaamheid-betrouwbaarheid.svg"
          />
        </div>
      </section>

      <div class="anchor-tag" id="voor-wie"></div>
      <section class="row clients">
        <clients></clients>
      </section>
      <section id="waar-doen-wij-dat" class="row">
        <div class="col text">
          <h1>Waar doen wij dat</h1>
          <p>
            Vanuit onze locaties verspreid over het hele land verzorgen wij uw
            opdrachten. Dankzij onze landelijke dekking bezorgen wij uw
            printopdrachten al de volgende werkdag.
          </p>
          <router-link class="link-button" to="/contact"
            >Bekijk hier onze vestigingen</router-link
          >
        </div>
        <div class="col image">
          <contact-map @select-vestiging="selectVestiging"></contact-map>
        </div>
      </section>
    </div>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from '../../components/SiteFooter.vue'
import Clients from './Clients.vue'
import ContactMap from './ContactMap.vue'
export default {
  components: { SiteFooter, Clients, ContactMap },
  methods: {
    selectVestiging(shop) {
      this.$router.push({
        name: 'contact',
        params: {
          contactShop: shop
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.row.wat-wij-doen {
  padding-top: 0;
  align-items: center;

  img {
    max-width: 375px;
  }
}

#hoe-doen-wij-dat {
  .image {
    padding-top: 0;
  }

  img {
    max-width: 300px;
  }
}

#waar-doen-wij-dat {
  align-items: center;
  .map-container {
    position: relative;
    max-width: 300px;
    display: inline-block;
  }
}

#printstore img {
  max-width: 365px;
}

#kwaliteit img {
  max-width: 350px;
}

.portals {
  max-width: 450px;
}

.archiveren {
  max-width: 360px;
}

#voor-wie {
}
</style>
